AgrimarketControllers.controller('commitmentsAllController', [
    '$scope', '$rootScope', '$routeParams', '$http', '$location', 'contractsService', '$filter', 'colonnesCropProductTonnages', 'enumFactory',
    function ($scope, $rootScope, $routeParams, $http, $location, contractsService, $filter, colonnesCropProductTonnages, enumFactory) {
        //appel iframe
}
]);